import { createSelector } from '@reduxjs/toolkit';
import { userWorkspaceManagerRole } from '../hooks/useWorkspaceManagerRight';
import { getMyWorkspaceSelector } from '../../workspace/selectors/Workspace.selectors';
import RightsApi from '../RightsAPI';
import { RootState } from '../../store.model';

type RIGHTS = 'editWorkspace';

const getMyRightsSelector = createSelector(
  [RightsApi.endpoints.getMyRights.select(undefined)],
  (rightsResponse) => rightsResponse.data || []
);

export const getIsManagerRoleSelectorInMainWorkspace = createSelector(
  [getMyRightsSelector, getMyWorkspaceSelector],
  (allRights, workspace) => {
    if (!workspace) {
      return false;
    }
    return userWorkspaceManagerRole(workspace, allRights);
  }
);

const hasRightInWorkspace = createSelector(
  [
    (_state, props: { workspaceId: string }) => props.workspaceId,
    (_state, props: { desiredRight: RIGHTS }) => props.desiredRight,
    getMyRightsSelector,
  ],
  (workspaceId, desiredRight, allRights) => {
    if (!workspaceId || allRights.length === 0) {
      return false;
    }
    const workspaceScope = `workspace:${workspaceId}`;
    return allRights.some((rightData) => {
      const scopeMatches = rightData.scope === workspaceScope;
      const hasRight = rightData.rights.find((right) => right === desiredRight);

      return scopeMatches && hasRight;
    });
  }
);

export const getHasEditWorkspaceRightSelector = createSelector(
  [
    (state: RootState) => state,
    (_state, props: { workspaceId: string }) => props.workspaceId,
  ],
  (state, workspaceId) =>
    hasRightInWorkspace(state, {
      workspaceId,
      desiredRight: 'editWorkspace',
    })
);
